// https://www.npmjs.com/package/moment-business-days
import moment from 'moment-business-days';
import {
  FIXED,
  MOBILE,
  // INTERNATIONAL,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
  IMPACT_LEVEL_3,
  IMPACT_LEVEL_4,
  RISK_LEVEL_1,
  RISK_LEVEL_2,
  RISK_LEVEL_3,
  RISK_LEVEL_4,
  WORKING_TIME_CUTOFF_HOUR,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';

const mo = 1;
const tu = 2;
const we = 3;
const th = 4;
const fr = 5;

// defines working days
moment.updateLocale('en', {
  workingWeekdays: [mo, tu, we, th, fr],
});

// defined holidays to be excluded from business days.
const newYear = '01-01-2025';
const goodFriday = '04-18-2025';
const easterMonday = '04-21-2025';
const mayBankHoliday = '05-05-2025';
const springBankHoliday = '05-26-2025';
const summerBankHoliday = '08-25-2025';
const christmas = '12-25-2025';
const boxingDay = '12-26-2025';
const TwentySixNewYear = '01-01-2026';
const TwentySixGoodFriday = '04-03-2026';
const TwentySixEasterMonday = '04-06-2026';
const TwentySixMayBankHoliday = '05-04-2026';
const TwentySixSpringBankHoliday = '05-25-2026';
const TwentySixSummerBankHoliday = '08-31-2026';
const TwentySixChristmas = '12-25-2026';
const TwentySixBoxingDay = '12-28-2026';
// const test = '05-16-2026';
// const test2 = '10-27-2023';

const holidaysList = [
  newYear,
  goodFriday,
  easterMonday,
  mayBankHoliday,
  springBankHoliday,
  summerBankHoliday,
  boxingDay,
  christmas,
  TwentySixNewYear,
  TwentySixGoodFriday,
  TwentySixEasterMonday,
  TwentySixMayBankHoliday,
  TwentySixSpringBankHoliday,
  TwentySixSummerBankHoliday,
  TwentySixChristmas,
  TwentySixBoxingDay,
  // test,
  // test2,
];

// moment.updateLocale('en', {
//   holidays: [newYear, goodFriday, easterMonday, mayBankHoliday, KingCharlesIIICoronationBankHoliday, springBankHoliday, jubileeBankHoliday, summerBankHoliday, boxingDay, christmas, test],
//   holidayFormat: 'MM-DD-YYYY',
// });
// check holiday date matches with current date
// const dateString = dateMoment.format('MM-DD-YYYY');
const isCrqDateHoliday = () => {
  const dateMoment = moment(new Date());
  const isDateHoliday = holidaysList.some((eachHoliday) => dateMoment.isSame(moment(eachHoliday, 'MM-DD-YYYY'), 'day'));
  return isDateHoliday;
};

// Include the UK bank holidays for fixed, mobile and OLO networks
// exclude the UK bank holidays for Intenrational network.
// const currentNetwork = window.sessionStorage.getItem('createNetowrk');
// commented from here moved to section 2 for ICM
// if (currentNetwork === FIXED || currentNetwork === MOBILE || currentNetwork === FIXEDOLO) {
//   moment.updateLocale('en', {
//     holidays: holidaysList,
//     holidayFormat: 'MM-DD-YYYY',
//   });
// }

// Functions to get the current day and current expedited time
// These need to be functions rather than the global scope otherwise
// you will get the time the module was loaded.

// Get midnight today
const getMidnightToday = () => {
  const time = moment.tz(DEFAULT_TIMEZONE);
  // reset time to midnight
  time.set('hour', 0).set('minute', 0).set('seconds', 0);
  return time;
};

// Expedited time on mobile is now + 2 hrs
const getExpeditedMobileTime = () => {
  const time = moment.tz(DEFAULT_TIMEZONE);
  // add two hours
  time.add(2, 'hour');
  return time;
};


// Emergency Fixed, International and OLO CRQ SLA Validation.
const getEmergencyFixedCRQTime = () => {
  const selectedTimeInMinutes = moment.tz(DEFAULT_TIMEZONE);
  const minTime = moment.tz(DEFAULT_TIMEZONE).add(15, 'minutes');
  const maxTime = moment.tz(DEFAULT_TIMEZONE).add(48, 'hours');

  if (selectedTimeInMinutes.isBefore(minTime)) {
    return minTime;
  }
  if (selectedTimeInMinutes.isAfter(maxTime)) {
    return maxTime;
  }
  const today = new Date();
  const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
  const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
  const UKNoonTime = moment('12:00:00', 'HH:mm:ss');

  // Ensure the CRQ is raised from the same day in the UK afternoon
  if (currentTimeMoment.isAfter(UKNoonTime)) {
    today.setHours(12, 0, 0, 0);
  }

  // Add the selected time in minutes to the current time
  const emergencyCRQTime = moment(today).add(selectedTimeInMinutes, 'minutes');

  return emergencyCRQTime.toISOString();
};

// Emergency Mobile CRQ SLA Validation
const getEmergencyMobileCRQTime = () => {
  const selectedTimeInMinutes = moment.tz(DEFAULT_TIMEZONE);
  const minTime = moment.tz(DEFAULT_TIMEZONE).add(15, 'minutes');
  const maxTime = moment.tz(DEFAULT_TIMEZONE).add(2, 'hours');

  if (selectedTimeInMinutes.isBefore(minTime)) {
    return minTime;
  }
  if (selectedTimeInMinutes.isAfter(maxTime)) {
    return maxTime;
  }
  const today = new Date();
  const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
  const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
  const UKNoonTime = moment('12:00:00', 'HH:mm:ss');

  // Ensure the CRQ is raised from the same day in the UK afternoon
  if (currentTimeMoment.isAfter(UKNoonTime)) {
    today.setHours(12, 0, 0, 0); // Set the time to UK noon if it's currently after noon
  }

  // Add the selected time in minutes to the current time
  const emergencyCRQTime = moment(today).add(selectedTimeInMinutes, 'minutes');

  return emergencyCRQTime.toISOString();
};

const OLO_LEAD_TIME = 2;
const INTERNATIONAL_LEAD_TIME = 5;
// For fixed expedited we use a max lead time as opposed to an actual lead time. This is because:
// if fixed expedited is 5 days and the impact level would normally make the lead time 2 days, we
// want the lead time to be 2 days, not 5 days (as it is shorter);
const expeditedMaxLeadTimeInDays = 5;



// if there's a bug in our code, worse case scenerio is the user can select an early date
// as such, we want to make sure that if there's a bug, they can only selected the furthest date
const FALL_BACK_LEAD_TIME_MOBILE = 10;
const FALL_BACK_LEAD_TIME_FIXED = 15;
const FALL_BACK_LEAD_TIME_OLO_FIXED = 10;
const FALL_BACK_LEAD_TIME_INTERNATIONAL = 15;
// if something goes drastically wrong and we can't determin if the CRQ is even fixed or mobile, we default to the biggest
// lead time possible
const ULTIMATE_FALL_BACK = FALL_BACK_LEAD_TIME_FIXED > FALL_BACK_LEAD_TIME_MOBILE ? FALL_BACK_LEAD_TIME_FIXED : FALL_BACK_LEAD_TIME_MOBILE;


// This is how we get lead time for mobile
const leadTimePerRiskLevel = {
  [RISK_LEVEL_1]: 3,
  [RISK_LEVEL_2]: 4,
  [RISK_LEVEL_3]: 6,
  // we use the fall back for risk value 4 as risk value 4 should always === the fall back
  [RISK_LEVEL_4]: FALL_BACK_LEAD_TIME_MOBILE,
};

// This is how we get lead time for fixed
const leadTimePerImpactLevel = {
  [IMPACT_LEVEL_1]: FALL_BACK_LEAD_TIME_FIXED,
  [IMPACT_LEVEL_2]: FALL_BACK_LEAD_TIME_FIXED,
  [IMPACT_LEVEL_3]: 2,
  [IMPACT_LEVEL_4]: 2,
};

// This is how we get lead time for International
const leadTimePerImpactLevelInternational = {
  [IMPACT_LEVEL_1]: FALL_BACK_LEAD_TIME_INTERNATIONAL,
  [IMPACT_LEVEL_2]: FALL_BACK_LEAD_TIME_INTERNATIONAL,
  [IMPACT_LEVEL_3]: 2,
  [IMPACT_LEVEL_4]: 2,
};



// returns the date for expedited OLO (which is expeditedMaxLeadTimeInDays unless leadTime is smaller)
const getExpeditedNowOLOFixed = (OloleadTime) => {
  const fixedNow = getMidnightToday();
  let expeditedLeadTimeInDays = expeditedMaxLeadTimeInDays < OloleadTime ? expeditedMaxLeadTimeInDays : OloleadTime;
  // adding extra day to the current SLA business days
  const today = new Date();
  const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
  const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
  const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
  if (currentTimeMoment.isAfter(UKNoonTime) || isCrqDateHoliday()) {
    expeditedLeadTimeInDays += 1;
  }
  const expeditedNowFixed = fixedNow.businessAdd(expeditedLeadTimeInDays);

  return expeditedNowFixed;
};

// returns the date for expedited fix (which is expeditedMaxLeadTimeInDays unless leadTime is smaller)
const getExpeditedNowFixed = (leadTime) => {
  const fixedNow = getMidnightToday();
  let expeditedLeadTimeInDays = expeditedMaxLeadTimeInDays < leadTime ? expeditedMaxLeadTimeInDays : leadTime;
  // adding extra day to the current SLA business days
  const today = new Date();
  const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
  const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
  const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
  if (currentTimeMoment.isAfter(UKNoonTime) || isCrqDateHoliday()) {
    expeditedLeadTimeInDays += 1;
  }
  const expeditedNowFixed = fixedNow.businessAdd(expeditedLeadTimeInDays);

  return expeditedNowFixed;
};

// returns the date for expedited International CRQ
const getExpeditedNowInternational = (leadTimeInternational) => {
  const internationalNow = getMidnightToday();
  let expeditedInternational = INTERNATIONAL_LEAD_TIME < leadTimeInternational ? INTERNATIONAL_LEAD_TIME : leadTimeInternational;
  // adding extra day to the current SLA business days
  const today = new Date();
  const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
  const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
  const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
  if ((currentTimeMoment.isAfter(UKNoonTime))) {
    expeditedInternational += 1;
  }
  const expeditedNowInternational = internationalNow.businessAdd(expeditedInternational);

  return expeditedNowInternational;
};
const getMinDateRaw = (params) => {
  const {
    selectedNetwork,
    riskValue,
    impactLevel,
    isExpedited,
    isOloCrq,
    isInternationalCrq,
    isEmergency,
    selectedTimeInMinutes,
  } = params;


  const midnightToday = getMidnightToday();

  if (selectedNetwork === MOBILE) {
    if (isExpedited === true) {
      return getExpeditedMobileTime().toISOString();
    }
    // When the Mobile Emergency CRQ selected
    if (isEmergency === true) {
      return getEmergencyMobileCRQTime(selectedTimeInMinutes).toISOString();
    }

    const leadTime = leadTimePerRiskLevel[riskValue];
    let days = leadTime ? leadTime : FALL_BACK_LEAD_TIME_MOBILE;
    // adding extra day to the current SLA business days
    const today = new Date();
    const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
    const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
    const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
    if (currentTimeMoment.isAfter(UKNoonTime) || isCrqDateHoliday()) {
      days += 1;
    }

    return midnightToday.businessAdd(days).toISOString();

  }
  if (selectedNetwork === FIXED && isInternationalCrq) {
    const leadTimeInternational = leadTimePerImpactLevelInternational[impactLevel];
    if (isExpedited === true) {
      return getExpeditedNowInternational(leadTimeInternational).toISOString();
    }
    // When the International Emergency CRQ selected
    if (isEmergency === true) {
      return getEmergencyFixedCRQTime(selectedTimeInMinutes).toISOString();
    }
    let days = leadTimeInternational ? leadTimeInternational : FALL_BACK_LEAD_TIME_INTERNATIONAL;
    // adding extra day to the current SLA business days ||
    const today = new Date();
    const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
    const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
    const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
    if ((currentTimeMoment.isAfter(UKNoonTime))) {
      days += 1;
    }
    return midnightToday.businessAdd(days).toISOString();
  }

  if (selectedNetwork === FIXED) {
    if (selectedNetwork === FIXED && isOloCrq) {
      const OloleadTime = OLO_LEAD_TIME;
      if (isExpedited === true) {
        return getExpeditedNowOLOFixed(OloleadTime).toISOString();
      }
      // When the OLO Emergency CRQ selected
      if (isEmergency === true) {
        return getEmergencyFixedCRQTime(selectedTimeInMinutes).toISOString();
      }
      let days = FALL_BACK_LEAD_TIME_OLO_FIXED ? FALL_BACK_LEAD_TIME_OLO_FIXED : ULTIMATE_FALL_BACK;
      // adding extra day to the current SLA business days
      const today = new Date();
      const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
      const UKNoonTime = moment('12:00:00', 'HH:mm:ss');
      if (currentTimeMoment.isAfter(UKNoonTime) || isCrqDateHoliday()) {
        days += 1;
      }

      return midnightToday.businessAdd(days).toISOString();
    }

    const leadTime = leadTimePerImpactLevel[impactLevel];

    if (isExpedited === true) {
      return getExpeditedNowFixed(leadTime).toISOString();
    }
    // When the FIXED Emergency CRQ
    if (isEmergency === true) {
      return getEmergencyFixedCRQTime(selectedTimeInMinutes).toISOString();
    }
    let days = leadTime ? leadTime : FALL_BACK_LEAD_TIME_FIXED;
    // adding extra day to the current SLA business days
    const today = new Date();
    const currentTimeCheck = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
    const currentTimeMoment = moment(currentTimeCheck, 'HH:mm:ss');
    const UKNoonTime = moment('12:00:00', 'HH:mm:ss');


    if (currentTimeMoment.isAfter(UKNoonTime) || isCrqDateHoliday()) {
      days += 1;
    }

    return midnightToday.businessAdd(days).toISOString();

  }

  const days = ULTIMATE_FALL_BACK;

  return midnightToday.businessAdd(days).toISOString();
};


const getInitialDate = (params) => {
  const {
    selectedNetwork,
    riskValue,
    impactLevel,
    isExpedited,
    isEmergency,
    isOloCrq,
    isInternationalCrq,
  } = params;
  const minDateRaw = getMinDateRaw({
    selectedNetwork,
    riskValue,
    impactLevel,
    isExpedited,
    isEmergency,
    isOloCrq,
    isInternationalCrq,
  });

  const initialDate = moment.tz(minDateRaw, DEFAULT_TIMEZONE);

  return initialDate.add(1, 'minute').toISOString();

};



const getMinDate = (params) => {
  const {
    selectedNetwork,
    riskValue,
    impactLevel,
    isExpedited,
    isEmergency,
    isOloCrq,
    isInternationalCrq,
  } = params;
  const minDateRaw = getMinDateRaw({
    selectedNetwork,
    riskValue,
    impactLevel,
    isExpedited,
    isEmergency,
    isOloCrq,
    isInternationalCrq,
  });

  const minDate = moment.tz(minDateRaw, DEFAULT_TIMEZONE);

  return Date.parse(minDate.toISOString());
};

const setDateToMidNight = (initialDate, timeZone = DEFAULT_TIMEZONE) => {
  const initialMomentDate = moment.tz(initialDate, timeZone);
  const initialMidNightDate = initialMomentDate.set('hour', 0).set('minute', 0).set('seconds', 0).set('milliseconds', 0);
  return initialMidNightDate;
};

const getEndDateFullDay = (endDateRaw, timeZone = DEFAULT_TIMEZONE) => {
  const endDate = moment.tz(endDateRaw, timeZone);
  const leadDays = (endDate.hour() > WORKING_TIME_CUTOFF_HOUR) ? 0 : 1;
  const endDateFullDay = moment(endDate).businessSubtract(leadDays, 'days');
  const endDateMidNight = setDateToMidNight(endDateFullDay, timeZone);
  return endDateMidNight;
};

const getStartDateFullDay = (startDateRaw, timeZone = DEFAULT_TIMEZONE) => {
  const startDate = moment.tz(startDateRaw, timeZone);
  const startDateFullDay = startDate.businessAdd(1, 'day');
  const startDateMidNight = setDateToMidNight(startDateFullDay, timeZone);
  return startDateMidNight;
};

const getBusinessDays = (startDateRaw, endDateRaw) => {
  const startDate = moment.tz(startDateRaw, DEFAULT_TIMEZONE);
  const endDate = moment.tz(endDateRaw, DEFAULT_TIMEZONE);
  return endDate.businessDiff(startDate, true);
};

const getFullBusinessDays = (startDateRaw, endDateRaw) => {
  const startDate = getStartDateFullDay(startDateRaw, DEFAULT_TIMEZONE);
  const endDate = getEndDateFullDay(endDateRaw, DEFAULT_TIMEZONE);
  const businessDays = startDate.isAfter(endDate) ? 0 : (endDate.businessDiff(startDate, true) + 1);
  return businessDays;
};

const getNextBusinessDays = (startDateRaw, commSLADays, timeZone = DEFAULT_TIMEZONE) => {
  /* eslint-disable */
  const today = moment();
  const startDate = moment.tz(startDateRaw, timeZone);
  const nextbusiness = startDate.businessSubtract(commSLADays)._d;
  const isAfter = moment(today).isAfter(nextbusiness);
  // const Todaysdate = new Date();
  // const ActualStartDate = new Date(nextbusiness);
  return isAfter;
}

const getNextHours = (Hours, timeZone = DEFAULT_TIMEZONE ) => {
  const moments = moment();
  const startDate = moment.tz(Hours, timeZone);
  const newDate = moment(startDate).add(2, 'hours').format('mm:ss S');
  console.log(startDate, moments+2, 'Moments', newDate);
  const now = moment();
  const expiration = moment(Hours);

// get the difference between the moments
  const diff = expiration.diff(now);

//express as a duration
  const diffDuration = moment.duration(diff);

// display
let expired = null;
if (diffDuration.days() >= 0) {
  console.log('1');
  if (diffDuration.days() === 0) {
    console.log('2');
    if(diffDuration.hours() >=0 ) {
      console.log('3');
      expired = false;
    }
    else {
      expired = true;
    }
  }
  else {
    expired = false;
  }
  console.log("Day:", diffDuration.days(), diffDuration.hours());
}
console.log("Days:", diffDuration.days());
console.log("Hours:", diffDuration.hours());
console.log("Minutes:", diffDuration.minutes(), expired, expired === null ? true: expired);
  return expired === null ? true: expired;
}
const getMaxDate = () => null; // no plans to implement... yet
const getEmergencyMaxDate = (params) => {
  const {
    selectedNetwork,
    isOloCrq,
    isInternationalCrq,
    isEmergency,
  } = params;
  // const minDateRaw = getMinDateRaw({
  //   selectedNetwork,
  //   riskValue,
  //   impactLevel,
  //   isExpedited,
  //   isOloCrq,
  //   isInternationalCrq,
  //   isEmergency,
  // });
 
  if ((selectedNetwork == FIXED || isOloCrq || isInternationalCrq) && isEmergency) {
    const currentDate = moment().tz(DEFAULT_TIMEZONE);
    return Date.parse(currentDate.add(48, 'hours').toISOString());
  }
  // if (selectedNetwork == FIXED && isInternationalCrq && isEmergency) {
  //   const currentDate = moment().tz(DEFAULT_TIMEZONE);
  //   return Date.parse(currentDate.add(48, 'hours').toISOString());
  // }
   if (selectedNetwork == MOBILE && isEmergency) {
    const currentDate = moment().tz(DEFAULT_TIMEZONE);
    return Date.parse(currentDate.add(2, 'hours').toISOString());
  }
  return null;
};

const getExcludeDates = () => []; // not implemented in phase one


export {
  getInitialDate,
  getExcludeDates,
  getMinDate,
  getMaxDate,
  getEmergencyMaxDate,
  setDateToMidNight,
  getStartDateFullDay,
  getEndDateFullDay,
  getBusinessDays,
  getFullBusinessDays,
  getNextBusinessDays,
  getNextHours,
  holidaysList,
};
